import { OrgMembershipRoleV1, type UserFullV1 } from "@/lib/api";

type WithMembership = Pick<UserFullV1, "membership">;

export function hasEdraMembership({ membership }: WithMembership): boolean {
  return membership?.organization.slug === "edra";
}

export function isOrgAdmin({ membership }: WithMembership): boolean {
  return membership?.role === OrgMembershipRoleV1.ADMIN;
}

export function isEdraOrgAdmin({ membership }: WithMembership): boolean {
  return (
    membership?.organization.slug === "edra" &&
    membership.role === OrgMembershipRoleV1.ADMIN
  );
}
